module.exports = __webpack_public_path__ + "img/san-jose-pool-2.7348b38a.jpg";